export default {
  common: {
    loginTitle: '登录',
    createPasswordTitle: '创建你的密码',
    forgetPasswordTitle: '忘记密码',
    resetPasswordTitle: '重置密码',
    questionnaireTitle: '入职信息填写',
    loginError: '用户名或密码错误',
    questionnaireFinished: '已完成入职信息',
    questionnaireFinishedText1: '恭喜你已完成了全部问题',
    toHomeBtn: '首页',
    email: '邮箱',
    alertTitle: '注意',
    btn: {
      forgetPassword: '忘记密码',
      reset: '重置'
    },
    message: {
      resetEmailSuccess: '重置密码邮件发送成功，请注意查收',
      wrongEmail: '无法重置密码，请检查填写的邮箱地址'
    }
  },
  nestle: {
    error: {
      fileNotUpload: '请上传附件',
      fileSizeError: '文件大小不能超过4MB',
      passwordTip: '密码必须包含大小写字母和数字，长度至少10位，特殊符号只能是_#@.-',
      passwordNotSame: '两次输入的密码不一致',
      isRequired: '该字段不能为空',
      noSteps: '未获取到文书工作具体步骤，请刷新后重试',
      serverError: '服务器内部错误',
      uploadError: '上传文件失败，请重试',
      uploadSuccess: '上传文件成功',
      phoneError: '电话格式不正确',
      birthIsNeeded: '需要提供出生日期。',
      ageTooSmall: '您已经指出您的年龄不足16岁。您必须至少16岁，这样才能为我们公司工作。',
      nameNotEn: '请检查并确保修改为拼音或英文名后方可进入下一页',
      nationalIDIssueDateIsNeeded: '要求提供国民身份证签发日期',
      nationalIDExpireDateIsNeeded: '要求提供国民身份证到期日期',
      nationalIDExpireLargeThanIssue: '国民身份证签发日期应当早于到期日期。',
      nationalIDExpireLargeThanNow: '国民身份证到期日期应该是将来的某个日期。',
      nationalIDRegex: '请输入有效的{nationID}。使用格式{format}',
      mustSelected: '该选项必须勾选',
      tryAgain: '请重试'
    },
    upload: '上传',
    fileChangedButNoUpload: '文件已修改但未上传， 确定离开？',
    year: '{year} 年',
    confirm: '确认',
    language: '语言',
    completeMyPaperwork: '完成我的文书工作',
    learning: '学习',
    myFirstDay: '我的第一天',
    createPassword: '创建你的密码',
    userName: '用户名',
    firstName: '名',
    lastName: '姓',
    password: '密码',
    reEnterPassword: '再次输入密码',
    agreeStatement: '我已经阅读并接受隐私内容协议',
    statementTitle: '隐私内容协议',
    statementBody: `
    <div style="font-size: medium;">
    以下声明会在您登陆入职准备平台前，在欢迎信链接中显示。
    <br><br>
    <div style="text-align: center;font-size: large;">声明</div>
    <br><br>
    本人特此签字确认：
    <br><br>
    - 登入全球入职门户站点，我可能会接触到雀巢S.A.、其子公司或附属公司专有的保密信息，从此信息被确定为保密信息之日起，由雀巢、其继承人或受让人（总称“雀巢”）管控，或由他们共同管控。此类保密信息可能涉及不为社会大众所知的雀巢业务、运营、员工、财务、专有产品和流程、方法、专有知识、制造工艺、系统改进、研发项目、技术、技术和商业数据、图纸、规范、业务计划以及雀巢业务相关的其它信息。
    <br><br>
    - 本人保证对此类信息进行保密，未事先获得雀巢书面许可，不会把此类信息直接或间接地披露给第三方，或用于准备雀巢未来雇佣外的其他用途。
    <br><br>
    - 本保密义务应当从我接受当前的声明之时起，到我在雀巢的雇佣开始日期止，在雀巢任职期间以及与雀巢的雇佣关系终止后，只要雀巢没有把相关的保密信息整体对社会公众披露，我都会对此类信息进行保密。
    <br><br>
    - 未经许可擅自披露保密信息，会给雀巢带来损害，本人可能会因此被提起法律诉讼，且不排除雀巢针对此等违约而在所有适用法律项下可以享有其它任何权利和赔偿。
    </div>
    `,
    toEmployeePortal: '去员工中心',
    createPasswordTitle: '创建你的密码',
    paperworkTitle: '入职信息填写',
    back: '返回',
    cancel: '取消',
    next: '下一步',
    finish: '完成',
    submit: '提交',
    newHirePaperwork: '新入职文书',
    paperworkStepZeroText1: '请按照以下流程填写信息。',
    paperworkStepZeroText2: '使用流程下方的按钮进行导航。',
    paperworkStepZeroText3: '点击取消键可以以后再进入文书页面填写信息，之前填写的信息会被保存。',
    followUs: '在<a href="http://www.nestle.com/change-country">社会媒体</a>上了解我们吧。访问主页，选择您的市场，找到您的国家的特定频道。',
    donnotBeShared: '本入职站点中的内容仅供您作为新员工时使用。处于版权原因，网站内容不得在雀巢外部分享。',
    learningPage: {
      learning: '学习',
      introduction: '本学习部分为您提供所需的相关信息，以妥善开启您在雀巢内部的旅程。',
      ourHistory: '我们的历史',
      ourHistoryDescription: '......由公司两名前辈讲述我们第一家工厂的确切地点！',
      ourPurpose: '我们的宗旨和价值观',
      ourPurposeDescription: '......是我们行事的基础，指导我们取得长期成功。',
      ourEnvironment: '我们的工作环境',
      ourEnvironmentDescription: '......您在雀巢工作可以寄予的期望。',
      messageFromMaurizioPatarnello: '来自Maurizio Patarnello的欢迎致辞',
      nestleWaters: '雀巢饮用水',
      cerealPartnersWorldwide: '进一步了解全球谷物联盟',
      messageFromJoeSivewright: '来自Joe Sivewright的欢迎致辞。',
      purinaHistory: '普瑞纳-历史',
      messageFromGregBehar: '来自Greg Behar的欢迎致辞',
      nestleHealthScience: '进一步了解雀巢健康科学',
      nestleNespresso: '雀巢奈斯派索'
    },
    landingPage: {
      title: '恭喜您！',
      subtitle: '很高兴您加入我们的团队。',
      introduction: '入职准备平台是您工作第一天之前，把我们作为一个待加入企业开始加以了解的地方。',
      subIntroduction: '开始您的入职之旅，准备享受您的工作第一天吧！',
      welcome: '欢迎来到雀巢',
      welcomeDescription: '敬请观看来自以下角色的欢迎致辞：',
      ourCEO: '公司执行总裁Mark Schneider ',
      paperwork: '完成我的文书工作',
      paperworkDescription: '为了妥善管理您的入职事宜，请在今后的三天内完成本部分。',
      myFirstDay: '我的工作第一天',
      myFirstDayDescription: '在这里找到更多关于您的工作场所的信息。',
      learning: '学习',
      learningDescription: '开始熟悉我们公司的文化和价值观。',
      welcomeTitle: '欢迎！',
      welcomeBody: `
      <div style="font-size: medium;">
      恭喜您！很高兴您加入我们的团队。这个入职准备站点将指导您了解所需的流程和要求，让您正式加入我们。除此以外，这个站点中还有对您有用的信息，帮助您在到达公司之前更好了解我们。
      <br><br>
      对您的首次操作而言，请前往“完成我的文书工作”标签页。
      </div>
      `,
      welcomeDontShow: '不要再次显示这个。',
      welcomeCompletePaperwork: '完成我的文书工作'
    },
    myFirstDayPage: {
      title: '我的第一天',
      introduction: '这个入职准备平台是您工作第一天之前，把我们作为一个待加入企业开始加以了解的地方。开始您的入职之旅，准备享受您第一天的工作吧！',
      gcr: '雀巢大中华区',
      china: '雀巢中国大陆',
      hk: '雀巢中国香港特别行政区',
      tw: '雀巢中国台湾',
      information: '您需要知道的信息'
    },
    myFirstDayPageCN: {
      title: '我的第一天',
      china: '雀巢中国大陆',
      information: '您需要知道的信息',
      chinaWebSite: '雀巢中国官网',
      gcrOffice: '雀巢大中华区总部办公室',
      linkedIn: '雀巢领英主页',
      cnWechatQR1: '雀巢中国微信公众号',
      cnWechatQR2: '雀巢中国微招聘'
    },
    myFirstDayPageTW: {
      title: 'My First Day',
      tw: 'Nestlé Taiwan, GCR',
      information: 'Information you need to know',
      twWebSite: 'Nestlé Taiwan Website',
      twOffice: 'Nestlé Taiwan Office',
      story: 'Nestlé Story',
      twYoutube: 'Nestlé Taiwan YouTube',
      twFacebook: 'Nestlé Taiwan Facebook'
    },
    myFirstDayPageHK: {
      title: 'My First Day',
      hk: 'Nestlé Hong Kong SAR, GCR',
      information: 'Information you need to know',
      hkWebSite: 'Nestlé HK Corporate Website',
      hkOffice: 'Nestlé Hong Kong Office (YL)',
      story: 'Nestlé Story'
    },
    paperworkHome: {
      title: '完成我的文书工作',
      introduction: '在本页中，您将找到在您工作第一天之前需要完成的所有重要的文书工作。',
      firstSubIntroduction: '我们公司致力于绿色技术并保护我们的环境。为此，法律允许时，新员工文书工作可以在这个安全的在线平台上完成。',
      secondSubIntroduction: '您正在提供的个人信息将会用来准备您入职雀巢的文书工作，构成您的员工生活的一部分。',
      step: '步骤',
      firstStepTitle: '输入您的信息',
      firstStepIntroduction1: '系统仅会要求您通过一系列页面，一次性输入您对的信息。 ',
      firstStepIntroduction2: '有些信息是可选的，有些信息是必填的。如果您错过了某个必填字段，门户将会将其突出显示。在每个页面的底部，您将看到以下按钮-<b>下一步、返回和关闭</b>。您可点击“<b>关闭</b>”来保存您所输入的信息，并在稍后继续。',
      firstStepIntroduction3: '在您完成文书工作后，您仍然有机会查看并编辑您的信息。',
      secondStepTitle: '签署您的文件',
      secondStepIntroduction1: '一旦您完成您的文书工作，系统可能会要求您在线签字（如果您所在的国家能够实现）。如果要求提供这种电子签名，选择“<b>点击签字</b>”按钮，您的表单会自动签名。',
      thirdStepTitle: '开始小提示',
      thirdStepIntroduction1: '确保您已经关闭了所有弹出窗口拦截，您的电脑的IE版本为9或以上，Adobe Reader的版本为4或以上。',
      thirdStepIntroduction2: '如果您准备开始，只需点击“<b>完成我的入职文书工作</b>”！',
      contact: '您可以与我联系\u3000',
      start: '现在开始并完成您的入职文书工作',
      finished: '您的入职文书工作已经完成'
    },
    nespresso: {
      title: 'Nespresso',
      introduction: '欢迎来到奈斯派索',
      sectionTitle1: 'Jean-Marc Duvoisin, CEO Nestle Nespresso',
      sectionTitle2: 'Learn more about Nespresso History',
      sectionTitle3: 'Nespresso Brand',
      sectionTitle4: 'Learn more about Nespresso Purpose & Values',
      sectionTitle5: 'Nespresso Priorities & Road Map'
    }
  }
}
